/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S7_P2Inputs */

const en_guide_what_is_json_s7_p2 = /** @type {(inputs: Guide_What_Is_Json_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A few habits make that easier. Keep a formatter open so minified payloads become readable in one paste. Validate before you assume the data is wrong, since a single missing brace can look like a logic bug for an hour. And when a structure is deeply nested, a tree view saves you from counting brackets by hand.`)
};

const ko_guide_what_is_json_s7_p2 = /** @type {(inputs: Guide_What_Is_Json_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`몇 가지 습관이 이를 쉽게 만듭니다. 포맷터를 열어두면 압축된 페이로드도 붙여넣기 한 번에 읽을 수 있습니다. 데이터가 잘못됐다고 단정하기 전에 먼저 검증하세요. 괄호 하나가 빠진 것이 한 시간 동안 로직 버그처럼 보일 수 있으니까요. 구조가 깊게 중첩됐다면 트리 뷰가 괄호를 일일이 세는 수고를 덜어줍니다.`)
};

const ja_guide_what_is_json_s7_p2 = /** @type {(inputs: Guide_What_Is_Json_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いくつかの習慣がそれを楽にします。フォーマッターを開いておけば、圧縮されたペイロードも貼り付け一回で読めます。データが間違っていると決めつける前に、まず検証しましょう。括弧が一つ抜けているだけで、一時間もロジックのバグのように見えることがあります。構造が深くネストしているときは、ツリービューが括弧を数える手間を省いてくれます。`)
};

/**
* | output |
* | --- |
* | "A few habits make that easier. Keep a formatter open so minified payloads become readable in one paste. Validate before you assume the data is wrong, since a..." |
*
* @param {Guide_What_Is_Json_S7_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s7_p2 = /** @type {((inputs?: Guide_What_Is_Json_S7_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S7_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s7_p2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s7_p2(inputs)
	return ja_guide_what_is_json_s7_p2(inputs)
});